export const home_path = '/';
export const creator_path = '/@/sellers';
export const shop_path = '/@/products';
export const curation_path = '/@/curations';
